import { render } from "./ProjectPopupHeader.vue?vue&type=template&id=6670c558&scoped=true&ts=true"
import script from "./ProjectPopupHeader.vue?vue&type=script&lang=ts"
export * from "./ProjectPopupHeader.vue?vue&type=script&lang=ts"

import "./ProjectPopupHeader.vue?vue&type=style&index=0&id=6670c558&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6670c558"]])

export default __exports__